import { Col, Row } from 'antd';
import { Column, Treemap } from '@ant-design/charts';
import { useUnit } from 'effector-react';
import { useEffect, useMemo } from 'react';
import {
  $analyticsData,
  $selectedOkedData,
  $selectedRegionData,
  changeSelectedOkedDataEv,
  changeSelectedRegionDataEv,
} from '../../../models/organizationsModel/index.js';
import { formatAnalyticsCharts } from '../../../models/organizationsModel/utils.jsx';
import style from './AnalyticStyles.module.css';

function AnalyticsCharts() {
  const analyticsData = useUnit($analyticsData);
  const selectedOkedData = useUnit($selectedOkedData);
  const selectedRegionData = useUnit($selectedRegionData);
  const changeSelectedOkedData = useUnit(changeSelectedOkedDataEv);
  const changeSelectedRegionData = useUnit(changeSelectedRegionDataEv);

  return (
    <Row style={{ marginTop: 20, position: 'relative' }} gutter={[20, 20]}>
      {/* {Object.keys(analyticsData).length === 0 && ( */}
      {/*  <div className={style.analytics_mask}> */}
      {/*    <div className={style.analytics_mask_message}>Выберите фильтры</div> */}
      {/*  </div> */}
      {/* )} */}
      <Col span={12}>
        <Column
          xField="type"
          yField="value"
          isStack
          seriesField="row"
          data={formatAnalyticsCharts(analyticsData.oked, 'columns')}
          onReady={(plot) => {
            plot.on('plot:click', (evt) => {
              const { x, y } = evt;
              const chosen_item = plot.chart.getTooltipItems({ x, y })[0].data;
              changeSelectedOkedData(chosen_item.type);
            });
          }}
        />
      </Col>
      <Col span={12}>
        <Column
          xField="type"
          yField="value"
          isStack
          seriesField="row"
          data={formatAnalyticsCharts(analyticsData.region, 'columns')}
          columnStyle={{
            shadowColor: 'rgba(0, 0, 0, 0.15)',
            shadowBlur: 10,
            shadowOffsetX: -4,
            shadowOffsetY: 4,
            radius: [4, 4, 0, 0],
          }}
          onReady={(plot) => {
            plot.on('plot:click', (evt) => {
              const { x, y } = evt;
              const chosen_item = plot.chart.getTooltipItems({ x, y })[0].data;
              changeSelectedRegionData(chosen_item.type);
            });
          }}
        />
      </Col>
      <Col span={12}>
        <Treemap
          data={formatAnalyticsCharts(
            selectedOkedData?.data || analyticsData.oked,
            'treeMap',
            !selectedOkedData
          )}
          colorField="name"
        />
      </Col>
      <Col span={12}>
        <Treemap
          data={formatAnalyticsCharts(
            selectedRegionData?.data || analyticsData.region,
            'treeMap',
            !selectedRegionData
          )}
          colorField="name"
        />
      </Col>
      <Col span={12}>
        <Column
          xField="type"
          yField="value"
          isStack
          seriesField="row"
          data={formatAnalyticsCharts(analyticsData.tax, 'columns')}
          columnStyle={{
            shadowColor: 'rgba(0, 0, 0, 0.15)',
            shadowBlur: 10,
            shadowOffsetX: -4,
            shadowOffsetY: 4,
            radius: [4, 4, 0, 0],
          }}
        />
      </Col>
    </Row>
  );
}

export default AnalyticsCharts;
